var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedUnclicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#BBBBBB;}\n\t.st1{fill:#BBBBBB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,18.5c0,0.8-0.9,1.7-1.7,1.7H5c0.6-0.6,0.9-1.4,0.9-1.9v-5.7V12v-0.2V0.8h14.3V18.5z M2.7,20.2 c-0.5,0-1.9-0.3-1.9-1.5v-6H5v5.7c0,0.6-0.7,1.9-1.9,1.9H2.7z M5,0v11.8H0v6.9C0,20.3,1.6,21,2.7,21h15.8c1.3,0,2.5-1.2,2.5-2.5V0 H5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 2.5,
    className: "st1",
    width: 10.9,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 13.9,
    className: "st1",
    width: 10.9,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 15.9,
    className: "st1",
    width: 10.9,
    height: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,10.9H8.4V6.3h9.2V10.9z M18.5,5.5H7.6v6.3h10.9V5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedUnclicked);
export default __webpack_public_path__ + "static/media/feed_unclicked.b561679f4a7b3b7985c643f4820661ef.svg";
export { ForwardRef as ReactComponent };